import { render } from "./viewPhotoItem.vue?vue&type=template&id=edd84abe&scoped=true"
import script from "./viewPhotoItem.vue?vue&type=script&lang=js"
export * from "./viewPhotoItem.vue?vue&type=script&lang=js"

import "./viewPhotoItem.vue?vue&type=style&index=0&id=edd84abe&lang=scss&scoped=scoped"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd84abe"]])

export default __exports__